<!-- <aside class="sidebar-menu" mode="side" *ngIf="acl"> -->
<ng-container *ngIf="acl">
    <!-- <div class="brand" tabindex="0" [ngClass]="{'disable-container-list': mfaMandatory}">
        <a class="nav-item" type="button" (click)="openHomePage()">
            <img class="small-logo" src="/assets/images/global/brand/brand-small.svg" alt="Countable"/>
            <img class="full-logo" src="/assets/images/logo/countable-header-logo.svg" alt="Countable"/>
        </a>
    </div> -->
    <ul role="list" class="left-nav m-0" [ngClass]="{'disable-container-list': mfaMandatory}">
        <!--Client-->
        <ng-container *ngIf="acl.isClient">
            <li role="list-item">
                <a class="nav-item" type="button" routerLink='/dashboard/clients/engagements' routerLinkActive="active"
                    (click)="viewPage('/dashboard/clients/engagements')"
                    [ngClass]="{'active': activePage == 'engagements', 'disable' : firm.isAccountLockedForBilling}"
                    area-label="Engagements">
                    <span class="nav-icon">
                        <img src="/assets/images/ui-uplift-icons/global/nav-icons/engagements.svg" alt="Icon">
                    </span>
                    <span class="nav-label">Engagements</span>
                </a>
            </li>
        </ng-container>
        <!-- partners and staff -->
        <ng-container *ngIf="!acl.isClient">
            <li role="list-item">
                <a class="nav-item" type="button" routerLink='/dashboard/members/Dashboard' routerLinkActive="active"
                    [ngClass]="{'active': activePage == 'Dashboard', 'disable' : (disableAccess || firm.isAccountLockedForBilling) }"
                    (click)="viewPage('/dashboard/members/Dashboard')" area-label="Dashboard">
                    <span class="nav-icon">
                        <img src="/assets/images/ui-uplift-icons/global/nav-icons/dashboard.svg" alt="Icon">
                    </span>
                    <span class="nav-label">Dashboard</span>
                </a>
            </li>
            <!-- only if the firm is onboarded -->
            <ng-container *ngIf="firm && firm.onboarded">
                <li role="list-item">
                    <a class="nav-item" type="button" routerLinkActive="active" routerLink='/dashboard/members/team'
                        routerLinkActive="active"
                        [ngClass]="{'active': activePage == 'firmpartners', 'disable' : (disableAccess || firm.isAccountLockedForBilling)}"
                        (click)="viewPage('/dashboard/members/team')" area-label="Team">
                        <span class="nav-icon">
                            <img src="/assets/images/ui-uplift-icons/global/nav-icons/teams.svg" alt="Icon">
                        </span>
                        <span class="nav-label">Team</span>
                    </a>
                </li>
                <li role="list-item">
                    <a class="nav-item" type="button" routerLinkActive="active" routerLink='/dashboard/members/clients'
                        routerLinkActive="active"
                        [ngClass]="{'active': activePage == 'firmclients', 'disable' : (disableAccess || firm.isAccountLockedForBilling)}"
                        (click)="viewPage('/dashboard/members/clients')" area-label="Clients">
                        <span class="nav-icon">
                            <img src="/assets/images/ui-uplift-icons/global/nav-icons/clients.svg" alt="Icon">
                        </span>
                        <span class="nav-label">Clients</span>
                    </a>
                </li>
                <li role="list-item">
                    <a class="nav-item" type="button" area-label="Engagements"
                        routerLink='/dashboard/engagement/engagement-list' routerLinkActive="active"
                        [ngClass]="{'active': activePage == 'engagement', 'disable' : (disableAccess || firm.isAccountLockedForBilling)}"
                        (click)="viewPage('/dashboard/engagement/engagement-list')">
                        <span class="nav-icon">
                            <img src="/assets/images/ui-uplift-icons/global/nav-icons/engagements.svg" alt="Icon">
                        </span>
                        <span class="nav-label">Engagements</span>
                    </a>
                </li>
                <li role="list-item" *ngIf="acl?.isSuperAdmin || userDetail?.istemplateenabled">
                    <a class="nav-item" type="button" routerLink='/dashboard/firm/templates/engagement-templates'
                        routerLinkActive="active" (click)="viewPage('/dashboard/firm/templates/engagement-templates')"
                        [ngClass]="{'active': activePage == 'templates', 'disable' : (disableAccess || firm.isAccountLockedForBilling)}"
                        area-label="Templates">
                        <span class="nav-icon">
                            <img src="/assets/images/ui-uplift-icons/global/nav-icons/templates.svg" alt="Icon">
                        </span>
                        <span class="nav-label">Templates</span>
                    </a>
                </li>
                <li role="list-item" *ngIf="isTrackerOn ? false : (acl.hasEngView && acl.hasTimeSummaryView)">
                    <a class="nav-item" type="button" routerLink='/dashboard/timetracking/time-summary'
                        routerLinkActive="active" (click)="viewPage('/dashboard/timetracking/time-summary')"
                        aria-label="Time Summary" [ngClass]="{'active': activePage == 'timetracking'}">
                        <span class="nav-icon">
                            <img src="/assets/images/ui-uplift-icons/global/nav-icons/time-summary.svg" alt="Icon">
                        </span>
                        <span class="nav-label">Time Summary</span>
                    </a>
                </li>
            </ng-container>
        </ng-container>
    </ul>
    <div class="user-detail-main border-top onboard-border-top">
        <!-- <app-side-menu-bottom (onCloseMenu)="onCloseMenu.emit()"></app-side-menu-bottom> -->
        <ul role="list" class="left-nav m-0">
            @if (firm && !firm.onboarded && isUserStartedOnboarding()) {
            <li role="listitem" class="user-info-item">
                <div #showStatus></div>
                @defer (on viewport(showStatus)) {
                <app-onboarding-status></app-onboarding-status>
                }
            </li>
            }
            <li role="list-item">
                <a class="nav-item text-white" type="button" routerLink="/dashboard/help/support">
                    <span class="nav-icon">
                        <i class="fa-regular fa-headset fs-20"></i>
                    </span>
                    <span class="nav-label">Support</span>
                </a>
            </li>
            

        </ul>
    </div>
</ng-container>
<!-- </aside> -->